export enum OrderByDirection{
    asc = 'ASC',
    desc = 'DESC'
}
